import React from 'react';

import { useSelector } from 'react-redux';

import { useFeatures } from '@atc/features';

import { AnalyticsEngine } from 'reaxl-analytics';

import globalAnalyticsHandlers from '@/analytics/globalAnalyticsHandlers';
import inventoryAnalytics from '@/analytics/inventoryAnalyticsHandlers';
import ownerAnalyticsHandlers from '@/analytics/ownerAnalyticsHandlers';
import srpAnalyticsHandlers from '@/analytics/srpAnalyticsHandlers';
import useAnalyticsPageEventListener from '@/analytics/useAnalyticsPageEventListener';
import useDataLayer from '@/analytics/useDataLayer';

import birfDuck from '@/ducks/birfDuck.js';
import globalConfigsDuck from '@/ducks/globalConfigsDuck.js';

import CookieConsentModule from '@/modules/CookieConsentModule.js';

function SRPAnalytics({ totalBoostCount }) {
    const {
        thirdparty: [enableThirdParty],
        google_analytics: [, { disableGtm, disableGtmEvents, delay }],
        oneTrust: [isOneTrustEnabled],
        optimizely_edge: [enableOptimizelyEdge],
    } = useFeatures([
        'thirdparty',
        'google_analytics',
        'oneTrust',
        'optimizely_edge',
    ]);

    const hasSuppressedCookies = useSelector(CookieConsentModule.duck.selectors.selectHasSuppressedGroup) && isOneTrustEnabled;
    const telmetricsKey = useSelector(globalConfigsDuck.selectors.getDuckState)?.telmetricsKey;

    const dataLayer = useDataLayer({ totalBoostCount });
    const analyticsPageEventListener = useAnalyticsPageEventListener();
    const dataIsland = useSelector(birfDuck.selectors.getPageData);

    const analyticsProps = {
        google: {
            delay,
        },
        disabled: hasSuppressedCookies,
        eventListener: analyticsPageEventListener,
        instanceId: dataLayer?.page?.pixallPageInstanceId,
        dataLayer: () => dataLayer,
        getDataIsland: () => dataIsland,
        value: {
            ...globalAnalyticsHandlers,
            ...inventoryAnalytics,
            ...ownerAnalyticsHandlers,
            ...srpAnalyticsHandlers,
        },
        option: {
            isOptimizelyEdge: enableOptimizelyEdge,
            disableGTM: disableGtm || !enableThirdParty,
            disableGTMEvents: disableGtmEvents,
            disablePixall: !enableThirdParty,
            telmetricsKey,
        },
    };

    return (<AnalyticsEngine {...analyticsProps} />);
}

export default React.memo(SRPAnalytics);
